import { createAsyncThunk } from "@reduxjs/toolkit";
import { connection, setConnection, log } from "./shared";

export const stopSignalRConnection = createAsyncThunk<
  void,
  void,
  { rejectValue: string }
>("signalr/stop", async (_, { rejectWithValue }) => {
  if (!connection) return;
  try {
    log("stopSignalRConnection: stopping", {
      hub: connection.connectionId,
      state: connection.state,
    });
    await connection.stop();
    log("stopSignalRConnection: stopped");
  } catch (e: unknown) {
    const message = e instanceof Error ? e.message : String(e);
    log("stopSignalRConnection: ERROR", { message });
    return rejectWithValue(message || "Failed to stop SignalR connection");
  } finally {
    setConnection(null);
    log("stopSignalRConnection: connection cleared");
  }
});
